function parseIsoDateParts(value) {
  const rawValue = String(value || '').trim();
  const match = rawValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) {
    return null;
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const parsedDate = new Date(Date.UTC(year, month - 1, day, 12, 0, 0));

  if (
    Number.isNaN(parsedDate.getTime())
    || parsedDate.getUTCFullYear() !== year
    || (parsedDate.getUTCMonth() + 1) !== month
    || parsedDate.getUTCDate() !== day
  ) {
    return null;
  }

  return { year, month, day, parsedDate };
}

export function getDefaultWrittenExamDate(examDate) {
  const parts = parseIsoDateParts(examDate);
  if (!parts) {
    return '';
  }

  const previousDay = new Date(parts.parsedDate);
  previousDay.setUTCDate(previousDay.getUTCDate() - 1);
  return previousDay.toISOString().slice(0, 10);
}

export function syncWrittenExamDateWithExamDate({ previousExamDate, nextExamDate, currentWrittenExamDate }) {
  const currentValue = String(currentWrittenExamDate || '').trim();
  const previousDefault = getDefaultWrittenExamDate(previousExamDate);
  const nextDefault = getDefaultWrittenExamDate(nextExamDate);

  if (!currentValue) {
    return nextDefault;
  }

  if (previousDefault && currentValue === previousDefault) {
    return nextDefault;
  }

  return currentValue;
}